import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navbar from './Navbar';
import './Layout.css';

const Layout = () => {
  const { user } = useAuth();

  return (
    <div className="layout">
      <Navbar user={user} />
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout; 